import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@/lib/navigation';
import { queryKeys } from '@/lib/query/query-keys';
import { apiFetch } from '@/lib/api/client';

async function deleteTrip(id: string): Promise<void> {
  const response = await apiFetch(`/api/v1/business-trip-requests/${id}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    const message =
      error?.error?.message ??
      error?.detail ??
      (typeof error === 'string' ? error : 'Failed to delete trip');
    throw new Error(message);
  }
}

export function useDeleteTrip() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: (id: string) => deleteTrip(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.trips });
      queryClient.invalidateQueries({ queryKey: queryKeys.tripApprovals });
      queryClient.removeQueries({ queryKey: queryKeys.trip(id) });

      router.push('/');
    },
    onError: (error: Error) => {
      console.error('Failed to delete trip:', error);
    },
  });
}
